/* eslint-disable1 */
// FWSD-5216 - video DOMException: play() failed because the user didn't interact with the document first
// To make the video autoplay on html 5 elements work after the chrome 66 update you just need to add the muted property to the video element.
// https://developer.chrome.com/blog/autoplay/ - Autoplay policy in Chrome
// https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide - Autoplay and autoplay blocking
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { useTranslation } from 'react-i18next'

import PermalinkVideo from './PermalinkVideo'
import PermalinkSnapshots from './PermalinkSnapshots'

import { apiCallGet } from '../../../action/RouterActions'

import 'bootstrap-slider/dist/css/bootstrap-slider.css'
import '../webplayer/webplayer.sass'
import './AdvancedPlayerPermalink.sass'

const AdvancedPlayerPermalink = (props) => {
	const { params, toggleLoader } = props;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'permalinksPage.advancedPlayerOpenClip' });

	const [state, setState] = useState({
		videoUrls: [],
		setNvrUrl: '',
		snapshotUrls: [],
		metadatasUrl: '',
		driver: '',
	});

	useEffect(() => {
		console.log('useEffect AdvancedPlayer props: ', props)
		toggleLoader(true)
		let funcName = ''
		if (props.location.pathname.includes('event/permalink')) {
			funcName = apiCallGet('/events/permalink/hash/{event_hash}', { event_hash: params.eventHash })
		}
		else {
			funcName = apiCallGet('/events/{permalink_id}/permalink', { permalink_id: params.permalinkID })
		}

		funcName
			.then((res, err) => {
				console.log('getPermalinkEventVideo res', res, err)
				const { response } = res.data
				// const tmp = {
				// 	"metadata_url": "https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/0000000000208416-240604-081540-081610-10U400000002.json?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=0JHmBoKHPBZGC1KM1wo20HI%2FSmg%3D&Expires=1720212355",
				// 	"nvr_url": "https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/0000000000208416-240604-081540-081610-10U400000002.nvr?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=y892p3IxVnJDIKcQWc4ZkbbL1zk%3D&Expires=1720212355",
				// 	"snapshots_urls": [
				// 		"https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/1.jpeg?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=6Za4n3Ea1%2F6RpXJ%2BshXz6WL0iRA%3D&Expires=1720212356",
				// 		"https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/2.jpeg?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=Kgsvf6byJCB40g2wqJIuXhxyCTU%3D&Expires=1720212356"
				// 	],
				// 	"video_urls": [
				// 		"https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/0000000000208416-240604-081540-081610-10U400000002_1.mp4?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=Qg1JVx2oaF3Up6bdDsCtVqnsVGQ%3D&Expires=1720212355",
				// 		"https://stages3.roscocloud.com/rosco-user-825/3983342988/2598910/0000000000208416-240604-081540-081610-10U400000002_2.mp4?AWSAccessKeyId=AKIAR34ZBXI7E5ZZ7R7C&Signature=MI15WSiUWcnxJgvb%2BVq3P0FOBH0%3D&Expires=1720212355"
				// 	]
				// }

				if (response.error) {
					toastr.error(i18n.t('errorMessage.errDescription'))
				}
				else {
					const { video_urls, nvr_url, snapshots_urls, driver, metadata_url } = response
					setState((prevState) => ({
						videoUrls: video_urls || [],
						setNvrUrl: nvr_url || '',
						snapshotUrls: snapshots_urls || [],
						metadatasUrl: metadata_url || '',
						driver: driver || '',
					}))
				}

				toggleLoader(false)
			})
			.catch((error) => {
				toggleLoader(false)
				console.log('!getPermalinkEventVideo error: ', error.response, error)
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			})
	}, [])

	if (state.videoUrls.length) {
		return <PermalinkVideo
			params={params}
			videoUrls={state.videoUrls}
			nvrUrl={state.nvrUrl}
			metadatasUrl={state.metadatasUrl}
			driver={state.driver}
		/>
	}
	if (state.snapshotUrls.length) {
		return <PermalinkSnapshots
			snapshotUrls={state.snapshotUrls}
		/>
	}

	return (
		<div>
			{t('eventNotExist')}
			{props.loader}
		</div>
	)
}

const mapStateToProps = ({ loader }) => ({
	loader: loader.loader,
})

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedPlayerPermalink);
